import {
  FormControl,
  MenuItem,
  Paper,
  Select,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core'
import { Fragment, useState } from 'react'
import {
  changeLanguageWithEvent,
  getCurrentLanguage
} from '../../translations/i18n'
import { MuiClasses } from '../../types'

const languages = [
  {
    label: 'FIN',
    value: 'fi'
  },
  {
    label: 'ENG',
    value: 'en'
  }
]

const styles = ({ breakpoints }: Theme) => ({
  container: {
    top: '20px',
    right: 0,
    zIndex: 1202,
    [breakpoints.down('sm')]: {
      marginLeft: '9px',
      marginBottom: '-6.5px',
      right: '32%',
      transform: 'translateX(10px)',
      textAlign: 'center' as any
    },
    [breakpoints.up('md')]: {
      position: 'fixed'
    }
  },
  font: {
    [breakpoints.down('md')]: {
      display: 'none'
    }
  },
  languageForm: {
    alignItems: 'center' as any,
    [breakpoints.up('md')]: {
      position: 'relative' as any,
      width: 80,
      textAlign: 'center' as any
    },
    '& svg': {
      color: '#fff'
    },
  }
})

const renderLanguage = (language: string, isMobile?: boolean) => (
  <Fragment>
    {isMobile ? <Typography variant='body1'>{language}</Typography> : language}
  </Fragment>
)

interface ChangeLanguageFormProps {
  classes: MuiClasses
  mobile?: boolean
  go?: any
  isApplication?: any
  style: any
}
const ChangeLanguageForm = ({
  classes,
  mobile,
  go,
  isApplication,
  style, // Accept style as a prop
}: ChangeLanguageFormProps) => {
  const [language, setLanguage] = useState<string>(getCurrentLanguage());
  const handleSetLanguage = (event: any) => {
    changeLanguageWithEvent(event);
    setLanguage(event.target.value);
    go && go(event.target.value);
  };

  const StyledPaper = withStyles({
    root: {
      backgroundColor: '#94004A',
      color: '#fff',
    },
  })(Paper);

  return (
    <StyledPaper
      square
      elevation={0}
      className={classes.container}
      style={{
        position: isApplication ? 'fixed' : 'static',
        ...style, // Apply custom styles passed as props
      }}
    >
      <FormControl className={classes.languageForm}>
        <Select
          style={{ color: '#fff', zIndex: 1203 }}
          disableUnderline
          onChange={handleSetLanguage}
          value={language}
          inputProps={{
            name: 'lang',
            id: 'lang',
          }}
        >
          {languages.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {renderLanguage(label, mobile)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StyledPaper>
  );
};

export default withStyles(styles)(ChangeLanguageForm);
